// extracted by mini-css-extract-plugin
export var hideEditor = "_mz-2";
export var infoIcon = "_mz-3";
export var label = "_mz-1";
export var labelContainer = "_mz-0";
export var readonlyText = "_mz-4";